import { get, isEmpty } from "lodash";
import { CheckoutCardThreeDSecureEnum } from "../shared/constants/CheckoutCardThreeDSecureEnum";
var has3DSActive = function (tokenResponse) {
    return (!isEmpty(get(tokenResponse, "secureId")) &&
        !isEmpty(get(tokenResponse, "security")) &&
        get(tokenResponse, "security.authRequired", false) &&
        get(tokenResponse, "secureService") ===
            CheckoutCardThreeDSecureEnum.THREEDSECURE);
};
var is3dsValid = function (secureOtpResponse) {
    return ("message" in secureOtpResponse &&
        ((secureOtpResponse.message === CheckoutCardThreeDSecureEnum["3DS000"] &&
            secureOtpResponse.code ===
                CheckoutCardThreeDSecureEnum.SECURE_OTP_RESPONSE_OK) ||
            (secureOtpResponse.message ===
                CheckoutCardThreeDSecureEnum.SECURE_OTP_RESPONSE_OK &&
                secureOtpResponse.code === CheckoutCardThreeDSecureEnum["3DS000"])));
};
export { has3DSActive, is3dsValid };
